module.exports = __webpack_public_path__ + "static/media/multi-sample-plp-tile-bg.6424222f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/invitations/single-sample-modal/multi-sample-plp-tile-bg.svg
// module id = 1730
// module chunks = 70